<div class="full-screen-container">
  <div class="close-button" (click)="close()">
    <mat-icon>close</mat-icon>
  </div>
  <div class="image-container">
    <img [src]="imageUrl" alt="Full Screen Image" />
  </div>
  <div class="title-container" *ngIf="title">
    <div class="title">{{ title }}</div>
  </div>
</div>
